import * as React from "react";
import {
	createLink,
	type LinkComponent,
	type RegisteredRouter,
	type ValidateLinkOptions,
} from "@tanstack/react-router";
import { cn } from "@bidbattles/bloks/lib/ui";

const RacLinkComponent = React.forwardRef<
	HTMLAnchorElement,
	React.ComponentProps<"a">
>(({ className, ...props }, forwardedRef) => {
	return (
		<a
			{...props}
			ref={forwardedRef}
			className={cn(
				"outline-gray-400 focus-visible:outline-offset-4",
				className,
			)}
		/>
	);
});

const CreatedLinkComponent = createLink(RacLinkComponent);

export const Link: LinkComponent<typeof RacLinkComponent> = (props) => {
	return <CreatedLinkComponent preload={"intent"} {...props} />;
};

export type LinkProps<
	TRouter extends RegisteredRouter = RegisteredRouter,
	TOptions = unknown,
	TDefaultFrom extends string = string,
> = ValidateLinkOptions<
	TRouter,
	TOptions,
	TDefaultFrom,
	typeof RacLinkComponent
>;
